import _regeneratorRuntime from "@babel/runtime/regenerator";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

import { asyncRunOnReadyState, monitorError, Observable } from '@datadog/browser-core';
import { getSessionReplayLink as _getSessionReplayLink } from '../domain/getSessionReplayLink';
import { startRecorderInitTelemetry } from '../domain/startRecorderInitTelemetry';
export function createPostStartStrategy(configuration, lifeCycle, sessionManager, viewHistory, loadRecorder, getOrCreateDeflateEncoder, telemetry) {
  var status = 0
  /* RecorderStatus.Stopped */
  ;
  var stopRecording;
  lifeCycle.subscribe(9
  /* LifeCycleEventType.SESSION_EXPIRED */
  , function () {
    if (status === 2
    /* RecorderStatus.Starting */
    || status === 3
    /* RecorderStatus.Started */
    ) {
      stop();
      status = 1
      /* RecorderStatus.IntentToStart */
      ;
    }
  });
  lifeCycle.subscribe(10
  /* LifeCycleEventType.SESSION_RENEWED */
  , function () {
    if (status === 1
    /* RecorderStatus.IntentToStart */
    ) {
      start();
    }
  });
  var observable = new Observable();
  startRecorderInitTelemetry(telemetry, observable);

  var doStart = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(forced) {
      var _yield$Promise$all, _yield$Promise$all2, startRecordingImpl, deflateEncoder, _startRecordingImpl;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              observable.notify({
                type: 'start',
                forced: forced
              });
              _context.next = 3;
              return Promise.all([notifyWhenSettled(observable, {
                type: 'recorder-settled'
              }, loadRecorder()), notifyWhenSettled(observable, {
                type: 'document-ready'
              }, asyncRunOnReadyState(configuration, 'interactive'))]);

            case 3:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
              startRecordingImpl = _yield$Promise$all2[0];

              if (!(status !== 2
              /* RecorderStatus.Starting */
              )) {
                _context.next = 9;
                break;
              }

              observable.notify({
                type: 'aborted'
              });
              return _context.abrupt("return");

            case 9:
              if (startRecordingImpl) {
                _context.next = 13;
                break;
              }

              status = 0
              /* RecorderStatus.Stopped */
              ;
              observable.notify({
                type: 'recorder-load-failed'
              });
              return _context.abrupt("return");

            case 13:
              deflateEncoder = getOrCreateDeflateEncoder();

              if (deflateEncoder) {
                _context.next = 18;
                break;
              }

              status = 0
              /* RecorderStatus.Stopped */
              ;
              observable.notify({
                type: 'deflate-encoder-load-failed'
              });
              return _context.abrupt("return");

            case 18:
              ;
              _startRecordingImpl = startRecordingImpl(lifeCycle, configuration, sessionManager, viewHistory, deflateEncoder, telemetry);
              stopRecording = _startRecordingImpl.stop;
              status = 3
              /* RecorderStatus.Started */
              ;
              observable.notify({
                type: 'succeeded'
              });

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function doStart(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  function start(options) {
    var session = sessionManager.findTrackedSession();

    if (canStartRecording(session, options)) {
      status = 1
      /* RecorderStatus.IntentToStart */
      ;
      return;
    }

    if (isRecordingInProgress(status)) {
      return;
    }

    status = 2
    /* RecorderStatus.Starting */
    ;
    var forced = shouldForceReplay(session, options) || false; // Intentionally not awaiting doStart() to keep it asynchronous

    doStart(forced)["catch"](monitorError);

    if (forced) {
      sessionManager.setForcedReplay();
    }
  }

  function stop() {
    if (status === 3
    /* RecorderStatus.Started */
    ) {
      stopRecording === null || stopRecording === void 0 ? void 0 : stopRecording();
    }

    status = 0
    /* RecorderStatus.Stopped */
    ;
  }

  return {
    start: start,
    stop: stop,
    getSessionReplayLink: function getSessionReplayLink() {
      return _getSessionReplayLink(configuration, sessionManager, viewHistory, status !== 0
      /* RecorderStatus.Stopped */
      );
    },
    isRecording: function isRecording() {
      return status === 3;
    }
    /* RecorderStatus.Started */

  };
}

function canStartRecording(session, options) {
  return !session || session.sessionReplay === 0
  /* SessionReplayState.OFF */
  && (!options || !options.force);
}

function isRecordingInProgress(status) {
  return status === 2
  /* RecorderStatus.Starting */
  || status === 3
  /* RecorderStatus.Started */
  ;
}

function shouldForceReplay(session, options) {
  return options && options.force && session.sessionReplay === 0
  /* SessionReplayState.OFF */
  ;
}

function notifyWhenSettled(_x2, _x3, _x4) {
  return _notifyWhenSettled.apply(this, arguments);
}

function _notifyWhenSettled() {
  _notifyWhenSettled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(observable, event, promise) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return promise;

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 4:
            _context2.prev = 4;
            observable.notify(event);
            return _context2.finish(4);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0,, 4, 7]]);
  }));
  return _notifyWhenSettled.apply(this, arguments);
}